
import AccountTaxAddressEdit from '~/pages/_lang/account/billing/edit/_id'
export default AccountTaxAddressEdit
